import { Sale } from "services/types/sales.type";
import { formatBackendDateOnly, formatMoney } from "utils/common";

export const getAdjustmentsTableHtml = (sale: Sale) => {
  let result = `<table style="border-collapse: collapse; width: 100%;" border="1"><colgroup><col style="width: 33.3333%;"><col style="width: 33.3333%;"><col style="width: 33.3333%;"></colgroup>
  <tbody>
    <tr>
      <td><strong>Date</strong></td>
      <td><strong>Description</strong></td>
      <td><strong>Amount</strong></td>
    </tr>`;

  sale?.adjustments?.forEach((adjustment) => {
    let row = `<td>${formatBackendDateOnly(
      adjustment.adjustment_date,
      "MMMM dd, yyyy"
    )}</td>`;

    row = row + `<td>${adjustment.description ?? ""}</td>`;

    row =
      row +
      `<td style="text-align: right">${formatMoney(
        Number(adjustment.amount),
        2
      )}</td>`;

    result = result + "<tr>" + row + "</tr>";
  });

  result =
    result +
    `<tr style="border: none">
      <td colspan="3"><br></td>
    </tr>`;

  result =
    result +
    `<tr style="border: none">
      <td colspan="2"><br></td>
      <td style="font-weight: 700;text-align: right">Adjustments Total: ${formatMoney(
        Number(sale.total_adjusted)
      )}</td>
    </tr>`;

  result = result + `</tbody></table>`;
  return result;
};
